import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ user, role, children }) {
  if (!user) return <Navigate to="/" />;

  if (role && user.role !== role) {
    return <div style={{ padding: 20 }}>No access</div>;
  }

  return children;
}